import gql from 'graphql-tag'

export const categoryFragment = gql`
    fragment categoryFragment on Category{
        id
        name
        description
        color
        label
        deleted_at
    }
`
